import Crud from './crud'
import { request_list, export_list, export_detail } from '@/commons/hpod';
var FileSaver = require('file-saver');
import Vue from 'vue';
var crud = new Crud('orders', 'xe hàng');

const state = {
    ...crud.state,
    order_detail: {},
    selected: {
        ID: 0
    }
};
const getters = {
    ...crud.getters,
};
const actions = {
    ...crud.actions,
    getDetailList({ commit }, param) {
        commit("setLoading", { loading: true });
        request_list('products', data => {
            commit('setDetailList', data);
            commit("setLoading", { loading: false });
        }, Vue.http, param, this.state.authentication.token);
    },
    exportList({ commit }, param) {
        export_list('orders', res => {
            var blob = new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;"});
            FileSaver.saveAs(blob, `XepXe_${new Date().getTime()}.xlsx`);
        }, Vue.http, param, this.state.authentication.token, 'export_list');
    },
    exportDetail({ commit }, param) {
        export_detail('orders', res => {
            var blob = new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;"});
            FileSaver.saveAs(blob, `XepXe_${new Date().getTime()}.xlsx`);
        }, Vue.http, param, this.state.authentication.token, 'export');
    }
};
const mutations = {
    ...crud.mutations,
    setDetailList(state, data) {
        state.order_detail = data;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};